import * as Tone from 'tone';
import { transpose } from "components/utils/helpers";
import MasterChannel from "./masterChannel"


export default class InstrumentBase {
  constructor(masterEffectSettings) {
    this.masterEffectSettings = masterEffectSettings
    this.settings = {}
    this.effectInstances = [];
    this.masterEffects = []
    this.channel = new Tone.Gain();
    this.input = new Tone.Gain();
    this.output = new Tone.Gain();
    this.setupMasterEffects()
    this.setupEffects();
    this.isLoaded = false;
    this.audioFilePath = "./audio/kits/";

    this.toneInstance = null;
  }
  setupEffects() {
    this.effectInstances = [];
    this.lastEffect = this.input;
    if (this.settings.effects) {
      for (let i = 0; i < this.settings.effects.length; i++) {
        const fxSettings = this.settings.effects[i];
        const effect = this.createEffect(fxSettings);
        this.effectInstances.push(effect);

        this.lastEffect.connect(effect);
        this.lastEffect = effect;
      }
    }
    this.lastEffect.connect(MasterChannel.master)
  }
  //master effects is connected before preset effects to be able to have master filter before reverb send
  setupMasterEffects() {
    this.lastMasterEffect = this.channel;
    if (this.masterEffectSettings.effects) {
      for (let i = 0; i < this.masterEffectSettings.effects.length; i++) {
        const fxSettings = this.masterEffectSettings.effects[i];
        const effect = this.createEffect(fxSettings);
        this.masterEffects.push(effect);
        this.lastMasterEffect.connect(effect);
        this.lastMasterEffect = effect;
      }
    }
    this.lastMasterEffect.connect(this.input)
  }
  toggleMasterEffect(id, active) {
    if (id === 0) {
      this.masterEffects[id].frequency.cancelScheduledValues()
      this.masterEffects[id].frequency.rampTo(active ? this.masterEffectSettings.effects[0].settings.frequency : 20000, 0.1);
    }
  }
  setMasterFilterFrequency(val, rampTime) {
    if (this.masterEffects.length && this.masterEffects[0].frequency) {
      this.masterEffects[0].frequency.cancelScheduledValues()
      this.masterEffects[0].frequency.rampTo(val, rampTime);
    }
  }
  removeAllEffects() {
    for (let i = 0; i < this.effectInstances.length; i++) {
      this.effectInstances[i].disconnect();
      this.effectInstances[i].dispose();
      this.effectInstances[i] = null;
    }
  }
  createEffect(fxSettings) {
    let fxInstance;
    switch (fxSettings.effectType) {
      case "BitCrusher":
        fxInstance = new Tone.BitCrusher(
          (fxSettings.settings && fxSettings.settings.bits) || 4
        );
        break;
      case "Distortion":
        fxInstance = new Tone.Distortion(
          (fxSettings.settings && fxSettings.settings.amount) || 0.4
        );
        break;
      case "Filter":
        fxInstance = new Tone.Filter(
          (fxSettings.settings && fxSettings.settings.startFrequency) || (fxSettings.settings && fxSettings.settings.frequency) || 200,
          (fxSettings.settings && fxSettings.settings.type) || "lowpass"
        );
        break;
      case "Convolver":
        fxInstance = new Tone.Channel();
        fxInstance.send(
          "convolverMaster",
          (fxSettings.settings && fxSettings.settings.wet) || -6
        );
        break;
      case "PingPongDelay":
        fxInstance = new Tone.Channel();
        fxInstance.send(
          "pingPongMaster",
          (fxSettings.settings && fxSettings.settings.wet) || -6
        );
        break;
      default:
        fxInstance = new Tone.Gain();
        break;
    }
    return fxInstance;
  }

  play(keyEvent = { frequency: 440 }) {
    this.toneInstance.triggerAttackRelease(keyEvent.frequency, "4n");
  }

  // Not used, Frequency call causes an error in react bc its not defined
  // noteOn(note, velocity) {
  //   const transposed = transpose(note, this.settings.octave);
  //   if (typeof transposed == "number") {
  //     this.toneInstance.triggerAttack(
  //       Frequency(transposed, "midi"),
  //       "+0.001",
  //       velocity
  //     );
  //   } else if (typeof note == "string") {
  //     this.toneInstance.triggerAttack(transposed, "+0.001", velocity);
  //   }
  // }

  // Not used, Frequency call causes an error in react bc its not defined
  // noteOff(note, velocity) {
  //   const transposed = transpose(note, this.settings.octave);
  //   if (typeof transposed == "number") {
  //     this.toneInstance.triggerRelease(
  //       Frequency(transposed, "midi"),
  //       "+0.001",
  //       velocity
  //     );
  //   } else if (typeof note == "string") {
  //     this.toneInstance.triggerRelease(transposed, "+0.001", velocity);
  //   }
  // }

  trigger(note, time) {
    if (note === undefined) return;

    if (!this.isLoaded) {
      console.warn("not loaded");
    }else {
      const transposed = transpose(note, this.settings.octave || 0);
      this.toneInstance.triggerAttackRelease(transposed, this.settings.instanceType === "Sampler" ? "4n" :"8n", time);
    }
  }

  setPreset(settings) {
    this.isLoaded = false;

    this.destroy();
    this.settings = settings;
    this.setVolume(this.settings.trackVolume);
    this.setupEffects();

    if (this.settings.instanceType === "Sampler") {
      let samplerSettings = {
        urls: this.settings.samples.urls,
        baseUrl: this.audioFilePath + this.settings.samples.baseUrl,
        onload: () => {
          this.isLoaded = true;
        }
      };
      this.toneInstance = new Tone.Sampler(samplerSettings).connect(
        this.channel
      );
    } else {
      if (settings.isPoly) {
        this.toneInstance = new Tone.PolySynth(
          Tone[settings.instanceType],
          settings.instanceSettings
        ).connect(this.channel);
      } else {
        this.toneInstance = new Tone[settings.instanceType](
          settings.instanceSettings
        ).connect(this.channel);
      }
      this.isLoaded = true;
    }
  }

  setVolume(val) {
    if (typeof val != "number") return;
    this.channel.gain.rampTo(val, 0.01);
  }

  destroy() {
    if (this.toneInstance) {
      this.toneInstance.dispose();
    }

    this.removeAllEffects();
  }
}
